export default __webpack_public_path__ + "static/media/bicycle-steve-mobile.68a8476b.jpg";